<template>
  <v-card class="mx-auto" flat>
    <v-card-text>
      <h1 class="headline info--text font-weight-bold"> Kelola Data Profil </h1>
      <v-divider class="my-4" />
      <v-row dense class="pa-2">
        <v-col v-for="(item, index) in schema" :key="index" v-bind="item.grid">
          <div class="subtitle-2 grey--text font-weight-regular">{{ item.label }} </div>
          <template v-if="item.type === 'text'">
            <template v-if="item.mask">
              <v-text-field
                v-model="form[item.value]"
                single-line
                dense
                :counter="item.max"
                :disabled="item.disable"
                v-mask="item.mask"
                outlined
                :placeholder="item.placeholder"
              ></v-text-field>
            </template>
            <template v-else>
              <v-text-field
                v-model="form[item.value]"
                single-line
                dense
                :disabled="item.disable"
                outlined
                :placeholder="item.placeholder"
              ></v-text-field>
            </template>
          </template>
          <template v-else-if="item.type === 'select'">
            <v-autocomplete
              v-model="form[item.value]"
              dense
              single-line
              :items="item.models"
              outlined
              :placeholder="item.placeholder"
            />
          </template>
          <template v-else>
            <v-file-input
              v-model="form[item.value]"
              :accept="['image/*']"
              outlined
              dense
              prepend-icon=""
              append-icon="mdi-paperclip"
              placeholder="Unggah Buku Tabungan"
            />
            <div class="subtitle-2 grey--text font-weight-regular">
              Unggah gambar cover Buku Tabungan dengan format JPG/JPEG/PNG
            </div>
          </template>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    initValue: {
      type: Object,
      default: () => null,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    schema() {
      const mBank = this.$getDeepObj(this, 'masters.bank') || {};

      return [
        {
          label: 'Nama Lengkap',
          value: 'nama',
          disable: true,
          type: 'text',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          label: 'Alamat Email',
          value: 'email',
          disable: true,
          type: 'text',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          label: 'Nomor Telepon',
          value: 'no_hp',
          required: true,
          mask: '############',
          max: 12,
          type: 'text',
          placeholder: 'Nomor HP',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          label: 'Asal Insansi',
          value: 'instansi_asal',
          type: 'text',
          required: true,
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          label: 'Nama Bank',
          value: 'rekening_bank',
          disable: false,
          required: true,
          type: 'select',
          models: this.$mapForMaster(mBank),
          placeholder: 'Pilih Bank',
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          label: 'Nomor Rekening',
          value: 'rekening_nomor',
          mask: '################',
          disable: false,
          required: true,
          max: 16,
          type: 'text',
          placeholder: 'Nomor Rekening',
          grid: { cols: 12, md: 3, sm: 12 },
        },
        {
          label: 'Nama Cabang',
          value: 'rekening_cabang',
          disable: false,
          required: true,
          type: 'text',
          placeholder: 'Nama Cabang',
          grid: { cols: 12, md: 6, sm: 12 },
        },
        {
          label: 'Nama Pemilik Rekening',
          value: 'rekening_nama',
          disable: false,
          required: true,
          type: 'text',
          placeholder: 'Nama Pemilik Rekening',
          grid: { cols: 12, md: 6, sm: 12 },
        },
      ];
    },
  },

  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      this.$set(this, 'form', value || {});
    },
  },

  watch: {
    initValue: 'initForm',
  },
};
</script>
